import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { formatDate } from '@angular/common';
import { Observable, Subject } from 'rxjs';
import { DataService } from '../services/data.service';
import { Query } from '../models/query.model';


@Injectable({
  providedIn: 'root'
})
export class SearchService {
  domains = ['decisions', 'proceedings', 'documents'];

  private showFullText = new Subject<boolean>();
  showFullText$ = this.showFullText.asObservable();

  _searchParams: any = {
    decisions: {},
    proceedings: {},
    documents: {}
  };

  constructor(
    private dataService: DataService,
    @Inject(LOCALE_ID) private locale: string
  ) { }

  get searchParams(): any {
    return this._searchParams;
  }

  set searchParams(value: any) {
    this._searchParams = value;
  }

  public getSearchResults(domain, facetMap: any, paramMap: any, rows: number, searchText: string,
    sortMap: any[], start: number): Observable<any> {

    // convert sortMap to API format:
    let _sortMap = [];
    if (sortMap) {
      _sortMap = sortMap.map(item => {
        const _item = {};
        _item[item.sortColumnName] = item.order;
        return _item;
      });
    }

    const _paramMap = {}, dateRangeMap = {};

    if(paramMap) {
      paramMap.forEach(element => {
        Object.keys(element).forEach(key => {
          if (typeof element[key] === 'object') {
            dateRangeMap[key] = element[key];
          } else {
            _paramMap[key] = element[key];
          }
        });
      });
    }
    let facetElements = {};
    if (facetMap) {
      try {
        facetMap.forEach(element => {
          const facetMapElement = JSON.parse(JSON.stringify(element));
          Object.keys(facetMapElement).forEach(key => {
            facetMapElement[key] = facetMapElement[key].map((item: any) => {
              const facetItem: any = {
                value: item.value
              };
              if (item.nestedFacetTypeName !== undefined) {
                facetItem.nestedFacetTypeName = item.nestedFacetTypeName;
                facetItem.nestedFacetNameBag = item.nestedFacetBag;
              }
              return facetItem;
            });
            facetElements[key] = facetMapElement[key];
          });
        });
      } catch (error) {
        console.error('error transforming facet-map', facetMap);
      }
    }
    facetMap = facetElements;

    const query: Query = new Query(
      dateRangeMap,
      facetMap,
      _paramMap,
      rows,
      searchText,
      _sortMap,
      start
    );

    this.publishShowFullText(false);
    return this.dataService.getSearchResults(domain, query);
  }

  public getSearchOptions(): Observable<any> {
    return this.dataService.getSearchOptions();
  }

  public getDateFilter() {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - 30);

    return {
      from: formatDate(start, 'yyyy-MM-dd', this.locale),
      to: formatDate(end, 'yyyy-MM-dd', this.locale)
    };
  }

    /**
   * Utility converts date value into string yyyy-mm-dd
   * @param date the date to convert
   */
  public getFormattedDate(date: Date): string {
    return date.getFullYear() + '-' +
      ('0' + String(date.getMonth() + 1)).substr(-2) + '-' +
      ('0' + String(date.getDate())).substr(-2);
  }

  public makeDate(date: string): Date {
    try {
      const arr = date.split('-').map(x => Number(x)).map((x, i) => (i === 1) ? x - 1 : x);
      return new Date(arr[0], arr[1], arr[2]);
    } catch (error) {
      console.error('make-date', error.message);
      return new Date();
    }
  }

  publishShowFullText(expand: boolean) {
    this.showFullText.next(expand);
  }

}
